// extracted by mini-css-extract-plugin
module.exports = {"RegisterPage":"RegisterPage"};